
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(068|3812|4032|4931)|2(16(7|80)|2019|6412)|5((39|70)42|5667)|6(1(453|733|906)|3294|4448|8865)|1(3918|5614|7989)|7(0374|8102|8298)|30887|80732|95206|97854)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
